import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaTelegramPlane, FaDiscord, FaTwitter } from "react-icons/fa";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  return (
    <Container fluid className="footer">
      <Row>
        <Col md="6" className="footer-copywright">
          <h3>Designed and Developed by DCRC</h3>
        </Col>
        <Col md="6" className="footer-copywright">
          <h3>Copyright © {year} DCRC.RACING</h3>
        </Col>
        <Col md="6" className="footer-body">
          <ul className="footer-icons">
            <li className="social-icons">
              <a
                href="https://t.me/DCRCRACEX"
                style={{ color: "white" }}
              >
                <FaTelegramPlane />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://twitter.com/dcrcavax"
                style={{ color: "white" }}
              >
                <AiOutlineTwitter />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://discord.gg/T5X76KBYSp"
                style={{ color: "white" }}
              >
                <FaDiscord />
              </a>
            </li>
          </ul>
        </Col>
        <Col md="6" className="footer-body">
            <a href="/copyr" target="_blank">Terms &amp; Conditions and Copyright</a>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
